var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { TextField } from '@material-ui/core';
import { Autocomplete } from '@material-ui/lab';
import React, { useMemo } from 'react';
import { useSiteContext } from '../../SiteContext';
const ComponentPicker = (_a) => {
    var { value, categories, clearable = false, onTypeChange } = _a, props = __rest(_a, ["value", "categories", "clearable", "onTypeChange"]);
    const { plugins } = useSiteContext();
    const filteredPlugins = useMemo(() => categories
        ? plugins.filter(p => categories.some(c => { var _a; return (_a = p.categories) === null || _a === void 0 ? void 0 : _a.includes(c); }))
        : plugins, [categories, plugins]);
    const InputProps = props.variant ? {} : { disableUnderline: true };
    return (React.createElement(Autocomplete, { fullWidth: true, disableClearable: !clearable, className: 'component-picker', value: value || '', options: (!value
            ? [...filteredPlugins, { type: '' }]
            : filteredPlugins).map(p => p.type), getOptionLabel: type => { var _a; return ((_a = filteredPlugins.find(p => p.type === type)) === null || _a === void 0 ? void 0 : _a.name) || type; }, getOptionSelected: (option, value) => option === value, onChange: (_, value) => onTypeChange === null || onTypeChange === void 0 ? void 0 : onTypeChange(value || ''), renderInput: params => (React.createElement(TextField, Object.assign({}, params, { fullWidth: true, size: 'small', InputProps: Object.assign(Object.assign({}, params.InputProps), InputProps) }, props))) }));
};
export default ComponentPicker;
//# sourceMappingURL=ComponentPicker.js.map